import {
  FormControl,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
} from '@chakra-ui/react'

interface SearchInputProps {
  inputRef: React.RefObject<HTMLInputElement | null>
  searchQuery: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFocus: () => void
  showResults: boolean
  isLoading?: boolean
}

export const SearchInput = ({
  inputRef,
  searchQuery,
  onChange,
  onFocus,
  showResults,
  isLoading,
}: SearchInputProps) => (
  <FormControl>
    <InputGroup
      display="flex"
      flexDirection="row"
      background="white"
      rounded="full"
      position="relative"
    >
      <Input
        ref={inputRef}
        placeholder="Search team members..."
        variant="brand-solid-white"
        rounded="full"
        value={searchQuery}
        onChange={onChange}
        onFocus={onFocus}
        autoFocus
        aria-label="Search team members"
        aria-expanded={showResults}
        aria-controls="team-members-dropdown"
        aria-autocomplete="list"
        role="combobox"
        isDisabled={isLoading}
      />
      {isLoading && (
        <InputRightElement>
          <Spinner size="sm" />
        </InputRightElement>
      )}
    </InputGroup>
  </FormControl>
)
